import Styles from 'screens/Campaign/Overview/EditChannelsModal/EditChannelsModal.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ContentsCount } from 'components/FirstTimeExperienceModal/steps/BrandPlanAwareness/ContentsCount'
import { useId } from '@react-aria/utils'
import { CountsSectionProps } from './Types'

export const CountsSection = ({ label, icon: Icon, name }: CountsSectionProps) => {
  const id = useId()
  return (
    <section className={Styles.countSection} role="group" aria-labelledby={id}>
      <header className={Styles.header}>
        <Icon size={24} />
        <Text variant="largeList" id={id}>
          {label}
        </Text>
      </header>
      <div className={Styles.content}>
        <ContentsCount name={name} withBorder />
      </div>
    </section>
  )
}
